<template>
    <div>
        <form @submit.prevent="validateBeforeSubmit">
            <div class="form-group row">
                <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Código:</label>
                <div class="col-sm-4">
                    <input type="number"
                            name="id"
                            v-validate="'required'"
                            :class="{'is-invalid' : errors.has('id')}"
                            v-model="form.id"
                            :disabled="editar"
                            class="form-control form-control-sm">
                    <span  class="invalid-feedback" v-show="errors.has('id')">{{ errors.first('id') }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Nome:</label>
                <div class="col-sm-10">
                    <input type="text"
                            name="nome"
                            v-validate="'required'"
                            :class="{'is-invalid' : errors.has('nome')}"
                            v-model="form.nome"
                            class="form-control form-control-sm">
                    <span  class="invalid-feedback" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
                </div>
            </div>

			<div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Time Zone:</label>
                <div class="col-sm-4">
                    <select type="text"
                            name="timeZone"
                            v-validate="'required'"
                            :class="{'is-invalid' : errors.has('timeZone')}"
                            v-model="form.timeZone"
                            class="form-control text-center form-control-sm">
						<option value="">ESCOLHA</option>
						<option v-for="(t, i) in timezones" :key="i" :value="t.Id">{{t.BaseUtcOffset}} ({{t.Id}})</option>
                    </select>
                    <span  class="invalid-feedback" v-show="errors.has('timeZone')">{{ errors.first('timeZone') }}</span>
                </div>
            </div>

            <div class = "form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Cor:</label>
                <div class="col-sm-4">
                    <select type="text"
                            name="cor"
                            v-validate="'required'"
                            :class="{'is-invalid' : errors.has('cor')}"
                            v-model="form.cor"             
                            class="form-control text-center form-control-sm">
                        <option value="">ESCOLHA</option>
                        <option v-for="value in cores" >{{value}}</option>
                    </select>
                    <span  class="invalid-feedback" v-show="errors.has('cor')">{{ errors.first('cor') }}</span>
                </div>
            </div>

			<div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Mascara:</label>
                <div class="col-sm-4">
					<select name="dateMask"
                            v-validate="'required'"
                            :class="{'is-invalid' : errors.has('dateMask')}"
                            v-model="form.dateMask"
                            class="form-control text-center form-control-sm">
						<option value="">ESCOLHA</option>
						<option value="dd/MM/yyyy">DD/MM/YYYY</option>
					</select>
                    <span  class="invalid-feedback" v-show="errors.has('dateMask')">{{ errors.first('dateMask') }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Token:</label>
                <div class="col-sm-10">
					<a href="#" @click.prevent="clickGerarToken()" v-tooltip="'Gerar Token'" class="ir"><fa-icon icon="random" /></a>
                    <input type="text"
                            name="token"
                            v-validate="'required'"
							:disabled="form.id != 0"
                            :class="{'is-invalid' : errors.has('token')}"
                            v-model="form.token"
                            class="form-control form-control-sm">
                    <span  class="invalid-feedback" v-show="errors.has('token')">{{ errors.first('token') }}</span>
                </div>
            </div>


			<div class="form-group row">
				<label for="inputPassword" style="margin-top: -8px" class="col-sm-2 col-form-label col-form-label-sm">Utiliza Manutenção?</label>
				<div class="col-sm-10">
						<toggle-button
									v-model="form.manutencao"
									:width="80"
									:height="30"
									:sync="true"
									:value="form.manutencao"
									:labels="{checked: 'SIM', unchecked: 'NÃO'}"
									:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
				</div>
			</div>

            <div class="form-group row">
				<label for="inputPassword" style="margin-top: -8px" class="col-sm-2 col-form-label col-form-label-sm">Usuário Ativo?</label>
				<div class="col-sm-10">
						<toggle-button
									v-model="form.ativo"
									:width="80"
									:height="30"
									:sync="true"
									:value="form.ativo"
									:labels="{checked: 'SIM', unchecked: 'NÃO'}"
									:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
				</div>
			</div>

            <hr />

			<h5>Ambientes:</h5>

            <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Teste:
				</label>
                <div class="col-sm-10">
					<a :href="form.linkTeste" class="ir" target="_blank">Ir <fa-icon icon="external-link-alt" /></a>
                    <input type="text"
                            name="nome"
							style="padding-right: 40px;"
                            v-model="form.linkTeste"
                            class="form-control form-control-sm">
                </div>
            </div>

            <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Homolog:
				</label>
                <div class="col-sm-10">
					<a :href="form.linkHomologacao" class="ir" target="_blank">Ir <fa-icon icon="external-link-alt" /></a>
                    <input type="text"
                            name="nome"
							style="padding-right: 40px;"
                            v-model="form.linkHomologacao"
                            class="form-control form-control-sm">
                </div>
            </div>

            <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Produção:
				</label>
                <div class="col-sm-10">
					<a :href="form.linkProducao" class="ir" target="_self">Ir <fa-icon icon="external-link-alt" /></a>
                    <input type="text"
                            name="nome"
							style="padding-right: 40px;"
                            v-model="form.linkProducao"
                            class="form-control form-control-sm">
                </div>
            </div>

            <hr/>

            <div class="row">
                <div class="col-sm-12 text-right">
                    <small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
                    <button class="btn btn-success btn-sm">
                        <fa-icon icon="check" transform="left-3" /> SALVAR
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<style>
.ir {
	position: absolute;
    right: 20px;
    top: 4px;
}
</style>


<script>
import axios from '../../routers/axios'
export default {

    props: {
        timezones: {
            type: Array,
            default: () => [],
        }
    },

    data(){
        return {
            editar: false,
            cores:["amarelo","azul", "cinza", "laranja", "preto", "roxo", "verde", "vermelho"],
            form: {
                id: "",
				nome: "",
				linkTeste: "",
				linkHomologacao: "",
				linkProducao: "",
				timeZone: "",
                cor: "",
				dateMask: "",
				manutencao: false,
            }
        }
    },

    mounted () {
    },

    methods: {

        carregaDados (item) {
            this.editar = true
            this.form.id = item.id
			this.form.nome = item.nome
			this.form.linkTeste = item.linkTeste
			this.form.linkHomologacao = item.linkHomologacao
			this.form.linkProducao = item.linkProducao
			this.form.timeZone = item.timeZone
            this.form.cor = item.cor
			this.form.dateMask = item.dateMask
			this.form.token = item.token
			this.form.manutencao = item.manutencao
            this.form.ativo = item.ativo
        },

        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.salva();
                }
            });
		},

		clickGerarToken() {
			this.form.token = this.generateToken(40)
			this.$forceUpdate()
		},

		generateToken(n) {
			var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
			var token = '';
			for(var i = 0; i < n; i++) {
				token += chars[Math.floor(Math.random() * chars.length)];
			}
			return token;
		},

        salva(){

            var data = {
                id: this.form.id,
				nome: this.form.nome,
				linkProducao : this.form.linkProducao,
				linkTeste : this.form.linkTeste,
				linkHomologacao : this.form.linkHomologacao,
				token: this.form.token,
				timeZone: this.form.timeZone,
				dateMask: this.form.dateMask,
				manutencao: this.form.manutencao,
                cor: this.form.cor,
			}

			this.$notify.loadIn('Salvando')

            if(this.editar){

                axios.put(this._getUrl(`api/cliente/${this.form.id}`), data).then(response => {
                    this.$emit('item-salvo', response.data)
                })

            } else {

                axios.post(this._getUrl('api/cliente'), data).then(response => {
                    this.editar = true
                    this.$emit('item-salvo', response.data)
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/cliente/cadastro.vue